import { Form } from '@ant-design/compatible'

import ManageExpertForm from './ManageExpertForm'

export default Form.create({
  name: 'expertForm',
})(ManageExpertForm)
